<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">Deleted Banners</h1>
          </div>
          <div class="col-sm-2">
            <router-link class="btn btn-primary" :to="{ name: 'all-banners' }">Back</router-link>
          </div>
        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">

            <div v-if="banners.length > 0">
              <MyTable :columns="columns" :actions="true">
                <tr v-for="(banner, index) in filteredBanners" :key="index">
                  <th scope="row">{{ banner.id }}</th>
                  <td>{{ banner.bannerable_type }}</td>
                  <td>{{ banner.related ? banner.related.name : 'N/A' }}</td>
                  <td>{{ banner.banner == 1 ? 'True' : 'False' }}</td>
                  <td>
                    <img :src="`${banner.image}`" width="50" height="50" class="img-thumbnail" />
                  </td>
                  <td>
                    <button class="me-2 btn btn-success" @click="restoreBanner(banner.id)">
                      Restore
                    </button>
                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No deleted Banners found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import $ from 'jquery'; // Import jQuery
import MyTable from "../MyTable//MyTable.vue";
import axios from "../../Axios";
export default {
  name: "DeletedBanners",
  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      dataTable: [],
      banners: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Banner Type', key: 'bannerable_type' },
        { label: 'Banner For', key: 'related.name' },
        { label: 'banner', key: 'banner' },
        { label: 'Image', key: 'image' },
      ],
    };
  },

  async created() {
    this.fetchBanners();
  },
  computed: {
    filteredBanners() {
      if (!this.searchTerm) {
        return this.banners;
      }
      const term = this.searchTerm.toLowerCase();
      return this.banners.filter(
        (banner) =>
          banner.name.toLowerCase().includes(term)

      );
    },
  },

  methods: {
    // fetch orders
    async fetchBanners() {
      try {
        const response = await axios.get(
          `/admin/admin/offer/get-delete-soft`
        );
        this.banners = response.data.data;
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        // Ensure the DataTable is initialized only after the DOM is updated
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    restoreBanner(id) {
      console.log("restore banner id: ", id);
      axios
        .post(`/admin/admin/offer/restore?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchBanners();
        })
        .catch((error) => {
          console.error(error);
        });
    },

  },
};
</script>

<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>